/* Friking — comportamiento de la ficha de producto (panel de información, guía de tallas, comprar ahora, carrusel de relacionados) */
(function () {
  'use strict';

  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
  var mobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  /* ---- Panel "Información producto" (móvil): se mueven los acordeones existentes al panel y se devuelven al cerrar ---- */
  function initPanel() {
    var btn = document.querySelector('.fk-info-btn');
    if (!btn) return;
    var panel = document.createElement('div');
    panel.className = 'fk-info-panel';
    panel.innerHTML = '<div class="fk-info-panel__bg"></div><div class="fk-info-panel__sheet" role="dialog" aria-modal="true" aria-label="Información del producto"><div class="fk-info-panel__head"><strong>Información del producto</strong><button type="button" class="fk-info-panel__close" aria-label="Cerrar">&times;</button></div><div class="fk-info-panel__body"></div></div>';
    document.body.appendChild(panel);
    var body = panel.querySelector('.fk-info-panel__body');
    var moved = [];

    function open(openId) {
      var acc = document.querySelectorAll('.fk-pdp .product__accordion');
      moved = [];
      acc.forEach(function (a) { moved.push({ node: a, parent: a.parentNode, next: a.nextSibling }); body.appendChild(a); });
      if (openId) { var d = body.querySelector('details[id^="Details-' + openId + '"]'); if (d) d.open = true; }
      else { var f = body.querySelector('details'); if (f) f.open = true; }
      panel.classList.add('is-open');
      document.body.classList.add('fk-no-scroll');
    }
    function close() {
      panel.classList.remove('is-open');
      document.body.classList.remove('fk-no-scroll');
      moved.forEach(function (m) { m.parent.insertBefore(m.node, m.next); });
      moved = [];
    }
    btn.addEventListener('click', function () { open(); });
    panel.querySelector('.fk-info-panel__bg').addEventListener('click', close);
    panel.querySelector('.fk-info-panel__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
    window.fkOpenInfoPanel = open;
  }

  /* ---- Enlace "Guía de tallas": abre el acordeón (escritorio) o el panel (móvil) ---- */
  function initSizeGuide() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.fk-size-guide');
      if (!a) return;
      e.preventDefault();
      var det = Array.prototype.slice.call(document.querySelectorAll('.fk-pdp .product__accordion details, .fk-info-panel details'))
        .filter(function (d) { return /gu[ií]a de tallas/i.test(d.textContent.slice(0, 80)); })[0];
      if (mobile() && window.fkOpenInfoPanel) {
        window.fkOpenInfoPanel();
        det = Array.prototype.slice.call(document.querySelectorAll('.fk-info-panel details')).filter(function (d) { return /gu[ií]a de tallas/i.test(d.textContent.slice(0, 80)); })[0];
      }
      if (det) { det.open = true; setTimeout(function () { det.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 50); }
    });
  }

  /* ---- Comprar ahora: añade al carrito con el mismo formulario y va directo al checkout ---- */
  function initBuyNow() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.fk-buynow');
      if (!b || b.disabled) return;
      var form = document.getElementById(b.getAttribute('data-form'));
      if (!form) return;
      var submit = form.querySelector('[type="submit"]');
      if (submit && (submit.disabled || submit.getAttribute('aria-disabled') === 'true')) return;
      b.disabled = true;
      var label = b.textContent;
      b.textContent = 'Procesando…';
      var idField = form.querySelector('[name="id"]');
      if (idField) idField.disabled = false;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'error');
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          b.disabled = false; b.textContent = label;
          var box = form.closest('product-form') || form;
          var msg = box.querySelector('.product-form__error-message');
          var wrap = box.querySelector('.product-form__error-message-wrapper');
          if (msg && wrap) { msg.textContent = String(err.message || 'No se pudo añadir el producto.'); wrap.removeAttribute('hidden'); }
          else alert(String(err.message || 'No se pudo añadir el producto.'));
        });
    });
  }

  /* ---- Carrusel de "También te gustará…" con flechas ---- */
  function initRelated() {
    var rel = document.querySelector('.related-products');
    if (!rel || rel.querySelector('.fk-rel__arrow')) return;
    var list = rel.querySelector('.product-grid');
    if (!list) return;
    rel.classList.add('fk-rel');
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'fk-rel__arrow fk-rel__arrow--prev'; next.className = 'fk-rel__arrow fk-rel__arrow--next';
    prev.setAttribute('aria-label', 'Anterior'); next.setAttribute('aria-label', 'Siguiente');
    prev.innerHTML = '&#8249;'; next.innerHTML = '&#8250;';
    rel.appendChild(prev); rel.appendChild(next);
    function step() { var it = list.querySelector('.grid__item'); return it ? it.getBoundingClientRect().width + 12 : 280; }
    function upd() { prev.hidden = list.scrollLeft < 8; next.hidden = list.scrollLeft + list.clientWidth >= list.scrollWidth - 8; }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    list.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---- Ampliación de imagen (lightbox) como en el ejemplo: clic en la foto, flechas, X, Esc y deslizar ---- */
  function initLightbox() {
    var box = null, imgEl, idx = 0, list = [], startX = null;
    function collect() {
      var out = [];
      document.querySelectorAll('.fk-pdp .product__media-list .product__media-item').forEach(function (li) {
        if (li.classList.contains('product__media-item--variant') || li.hidden) return;
        var im = li.querySelector('img');
        if (!im) return;
        var src = (im.currentSrc || im.src || '').replace(/([?&])width=\d+/, '$1width=1600');
        if (/width=/.test(src) === false && src.indexOf('?') > -1) src += '&width=1600';
        out.push({ id: li.getAttribute('data-media-id'), src: src, alt: im.alt || '' });
      });
      return out;
    }
    function build() {
      box = document.createElement('div');
      box.className = 'fk-lb';
      box.innerHTML = '<div class="fk-lb__bg"></div><div class="fk-lb__frame" role="dialog" aria-modal="true" aria-label="Imagen ampliada"><img class="fk-lb__img" alt=""><button type="button" class="fk-lb__prev" aria-label="Anterior">&#8249;</button><button type="button" class="fk-lb__next" aria-label="Siguiente">&#8250;</button></div><button type="button" class="fk-lb__close" aria-label="Cerrar">X</button>';
      document.body.appendChild(box);
      imgEl = box.querySelector('.fk-lb__img');
      box.querySelector('.fk-lb__bg').addEventListener('click', close);
      box.querySelector('.fk-lb__close').addEventListener('click', close);
      box.querySelector('.fk-lb__prev').addEventListener('click', function () { go(-1); });
      box.querySelector('.fk-lb__next').addEventListener('click', function () { go(1); });
      var fr = box.querySelector('.fk-lb__frame');
      fr.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      fr.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX; startX = null;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      });
    }
    function show() {
      imgEl.src = list[idx].src; imgEl.alt = list[idx].alt;
      var multi = list.length > 1;
      box.querySelector('.fk-lb__prev').hidden = !multi; box.querySelector('.fk-lb__next').hidden = !multi;
    }
    function go(d) { idx = (idx + d + list.length) % list.length; show(); }
    function open(i) {
      list = collect(); if (!list.length) return;
      if (!box) build();
      idx = Math.max(0, Math.min(i, list.length - 1));
      show();
      box.classList.add('is-open'); document.body.classList.add('fk-no-scroll');
    }
    function close() { if (box) { box.classList.remove('is-open'); document.body.classList.remove('fk-no-scroll'); } }
    document.addEventListener('keydown', function (e) {
      if (!box || !box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1);
    });
    /* captura el clic antes que el modal del tema */
    document.addEventListener('click', function (e) {
      var c = e.target.closest('.fk-pdp .product__media-list .product-media-container');
      if (!c || c.classList.contains('media-type-video') || c.classList.contains('media-type-external_video') || c.classList.contains('media-type-model')) return;
      var li = c.closest('.product__media-item'); if (!li) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var id = li.getAttribute('data-media-id'), i = 0;
      collect().forEach(function (m, k) { if (m.id === id) i = k; });
      open(i);
    }, true);
  }

  ready(function () {
    initPanel(); initSizeGuide(); initBuyNow(); initLightbox();
    initRelated();
    /* los relacionados se cargan por AJAX: reintenta cuando aparezcan */
    var rel = document.querySelector('product-recommendations.related-products');
    if (rel) new MutationObserver(function () { initRelated(); }).observe(rel, { childList: true, subtree: true });
  });
})();
